// ******** fotoperfil.jsx *********
// ******** autor: Walcledson de Paula
// ******** data: 09/07/24 23h11 implementação do tirar/carregar foto
// ***********************************




import React, { useState } from 'react';
import Swal from 'sweetalert2';
import apiaxios from '../../../../Services/apiaxios';
const Profile = (props) => {
    const [isEditable, setIsEditable] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);

    const handleEditProfile = () => {
        setIsEditable(true);
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setSelectedFile(reader.result);
                Swal.fire({
                    title: 'Confirmação',
                    text: 'Confirma esta foto/imagem?',
                    imageUrl: reader.result,
                    showCancelButton: true,
                    confirmButtonText: 'Sim, confirmo!',
                    cancelButtonText: 'Cancelar'
                }).then((result) => {
                    if (result.isConfirmed) {
                        handleUploadPhoto(reader.result);
                    }
                });
            };
            reader.readAsDataURL(file);
        }
    };

    const handleUploadPhoto = async (base64Photo) => {
        try {
            const response = await apiaxios.put('/usuario/TrocarFoto', {
                id_usuario: 123, // Substitua pelo ID do usuário logado
                foto: base64Photo
            });

            if (response.status === 200 && response.data.retorno === 'OK') {
                Swal.fire('Sucesso', 'Foto salva com sucesso!', 'success');
            } else {
                Swal.fire('Erro', 'Falha ao salvar a foto. Tente novamente mais tarde.', 'error');
            }
        } catch (error) {
            Swal.fire('Erro', 'Falha ao salvar a foto. Tente novamente mais tarde.', 'error');
        }
    };

    return (
        <div>
            {/* Seu código de perfil existente */}

            <button onClick={handleEditProfile}>Alterar dados do perfil</button>
            {isEditable && (
                <div>
                    <input
                        type="file"
                        accept="image/*"
                        capture="user"
                        onChange={handleFileChange}
                        style={{ display: 'none' }}
                        id="cameraInput"
                    />
                    <button onClick={() => document.getElementById('cameraInput').click()}>Câmera</button>

                    <input
                        type="file"
                        accept="image/*"
                        onChange={handleFileChange}
                        style={{ display: 'none' }}
                        id="galleryInput"
                    />
                    <button onClick={() => document.getElementById('galleryInput').click()}>Galeria</button>
                </div>
            )}
        </div>
    );
};

export default Profile;
